import { css, cssManager } from '@design.estate/dees-element';

export const tilePdfStyles = css`
  .preview-stack {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 10px;
  }

  .preview-stack.non-a4 {
    padding: 12px;
  }

  .preview-canvas {
    position: relative;
    background: white;
    border-radius: 2px;
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    image-rendering: auto;
    -webkit-font-smoothing: antialiased;
    box-shadow: var(--dees-shadow-sm);
  }

  .non-a4 .preview-canvas {
    border: 1px solid var(--dees-color-border-default);
    border-radius: 2px;
  }

`;
